import { render, staticRenderFns } from "./ModalHistoricoClassificacao.vue?vue&type=template&id=3907aa00&scoped=true"
import script from "./ModalHistoricoClassificacao.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoClassificacao.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoClassificacao.vue?vue&type=style&index=0&id=3907aa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907aa00",
  null
  
)

export default component.exports